import React from 'react';
import { Observe } from 'rewire-core';
import { WithStyle, FormView, Modal } from 'rewire-ui';
import { Theme } from '@material-ui/core/styles';
import DraggableResizableDialog2 from '../ui/DraggableResizableDialog2';
import TitleWithFlowLogo from '../ui/TitleWithFlowLogo';
import switchLocationsModel from './SwitchLocationsModel';
import { withStyles } from '../utility/styles';

const styles = (theme: Theme) => ({
  linkContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    margin: '0px 16px',
    '& > a': {
      color: theme.palette.dialogPrimary.main,
      '&:hover': {
        color: theme.palette.dialogPrimary.light,
      },
    },
  },
});

interface ISwitchLocationsProps {}

type SwitchLocationsProps = WithStyle<ReturnType<typeof styles>, ISwitchLocationsProps>;

class SwitchLocations extends React.Component<SwitchLocationsProps> {
  componentWillUnmount() {
    switchLocationsModel.reset();
  }

  renderTitle = (_dialog: Modal): JSX.Element => {
    return <TitleWithFlowLogo beforeText="Switch to" />;
  };

  renderDialogContents = React.memo((): JSX.Element => {
    return (
      <Observe
        render={() => (
          <FormView form={switchLocationsModel.form} onSubmit={switchLocationsModel.actionFn('switch location')}>
            <div className="content">
              <switchLocationsModel.form.field.location.Editor className="span1" />
            </div>
          </FormView>
        )}
      />
    );
  });

  render() {
    return (
      <Observe
        render={() => {
          return switchLocationsModel.isOpen ? (
            <div>
              <DraggableResizableDialog2
                defaultWidth="xs"
                DialogProps={{ dialog: switchLocationsModel, title: this.renderTitle }}
                DraggableResizableBoxProps={{ minWidth: '296px', minHeight: '210px' }}
              >
                <this.renderDialogContents />
              </DraggableResizableDialog2>
            </div>
          ) : null;
        }}
      />
    );
  }
}

export default withStyles<ISwitchLocationsProps>(styles, SwitchLocations);
